module.exports = __webpack_public_path__ + "img/icon-round-lose.fba69092.png";